import styled, { css } from 'styled-components';
import { boxStyles } from '../Box/styles.js';
import { boxStyledOptions } from '../utils/helpers/styled.web.js';

var autocomplete = /*#__PURE__*/styled.div.withConfig(boxStyledOptions).withConfig({
  displayName: "styles__autocomplete",
  componentId: "sc-r3zsjg-0"
})(["position:relative;width:100%;", ""], boxStyles);
var inputWrap = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__inputWrap",
  componentId: "sc-r3zsjg-1"
})(["position:relative;z-index:4;", ""], function (p) {
  return p.$opened && css(["input{border-color:", ";}"], p.$color);
});

export { autocomplete, inputWrap };
